import { Component, OnInit } from '@angular/core';
import { ParEmployeeService } from '../../services/par_employees/par_employees.service';
import { ParEmployee } from '../../model/par_employees.model';

@Component({
  selector: 'app-agents',
  templateUrl: './par_employees.component.html',
  styleUrls: ['./par_employees.component.css'],
  providers: []
})
export class PAREmployeeComponent implements OnInit {
  employees: ParEmployee[];
  employee: ParEmployee;
  first_name: String;
  middle_name: String;
  last_name: String;
  email: String;
  password: String;
  role: String;
  loginId;
  selectedRoleOption = "PAR_EMPLOYEE";
  roleOptions = [
    { value: 'PAR_EMPLOYEE', viewValue: 'PAR Employee' },
    // { value: 'PAR_MANAGER', viewValue: 'PAR Manager' }
  ];
  constructor(private parEmployeeService: ParEmployeeService) { }

  getOptions(data) {
    this.selectedRoleOption = data.target.value;
  }

  // add PAR employee function
  addEmployee() {
    const newEmployee = {
      first_name: this.first_name,
      last_name: this.last_name,
      middle_name: this.middle_name,
      email: this.email,
      password: this.password,
      role: this.selectedRoleOption,
      created_by: this.loginId,
      updated_by: this.loginId

    };
    this.first_name = null;
    this.last_name = null;
    this.middle_name = null;
    this.email = null;
    this.password = null;
    this.role = null;

    this.parEmployeeService.addParEmployee(newEmployee)
      .subscribe(employees => {
        this.employees.push(employees);
        this.parEmployeeService.getParEmployees()
          .subscribe(employees =>
          this.employees = employees);
      });
  }

  // delete PAR employee function
  deleteEmployee(id: any) {
    const employees = this.employees;
    this.parEmployeeService.deleteParEmployee(id)
      .subscribe(data => {
        if (data.n === 1) {
          for (let i = 0; i < employees.length; i++) {
            if (employees[i]._id === id) {
              employees.splice(i, 1);
            }
          }
        }
      this.parEmployeeService.getParEmployees()
      .subscribe(response =>
      this.employees = response);
      });
  }

  ngOnInit() {
    this.parEmployeeService.getParEmployees()
      .subscribe(response =>
      this.employees = response);
      this.loginId = localStorage.getItem('loginID');
  }

}



// WEBPACK FOOTER //
// ./src/app/components/par_employees/par_employees.component.ts